import React from 'react'
import { Tabs } from 'antd'

import styled from '@src/styled-components'
import I18n from '@src/i18n'
import SchedulingService from '@services/graphQLSchedulingService'
import { StatusProcess } from '@helpers/Enums'
import ProcessRequestsInterceptor from '@src/helpers/interceptors/ProcessRequestInterceptor'
import TableComponent from '@components/TableComponent';
import SearchComponent from '@components/MyProcesses/SearchComponent'

const moment = require('moment')
const { TabPane } = Tabs

class MyProcessesContainer extends React.Component<any, any> {
  private processGraphQL: any = new SchedulingService()
  private processService: any = new ProcessRequestsInterceptor()
  private userId: any
  private userName: any
  private unitId: any
  private tableColumns = [{
    title: 'table.formflow.name',
    dataIndex: 'name',
    key: 'name',
    class: 'name'
  }, {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    width: '30%'
  }, {
    title: 'table.actions',
    dataIndex: 'action',
    key: 'action',
    width: '20%'
  }]

  constructor(props: any) {
    super(props)

    this.userId = localStorage.getItem('userId')
    this.userName = localStorage.getItem('username')
    this.unitId = localStorage.getItem('activeUnitId')

    this.state = {
      activeTab: 'scheduled',
      scheduledRAW: [],
      unscheduledRAW: [],
      scheduled: [],
      unscheduled: [],
      isLoadingScheduled: false,
      isLoadingUnscheduled: false,
      currentFilter: [1, 5],
      search: '',
      filteredScheduled: [],
      filteredUnscheduled: []
    }

    this.handleExecScheduled = this.handleExecScheduled.bind(this)
    this.handleExecUnscheduled = this.handleExecUnscheduled.bind(this)
    this.handleChangeFilters = this.handleChangeFilters.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.filteredData = this.filteredData.bind(this)
    this.loadScheduled = this.loadScheduled.bind(this)
  }

  componentDidMount () {
    this.loadScheduled()
    this.loadUnscheduled()
  }

  componentDidUpdate (prevProps: any, prevState: any) {
    const { currentFilter, search } = this.state
    if (prevState.search !== search || prevState.currentFilter !== currentFilter) {
      this.filteredData()
    }
  }

  async loadScheduled () {
    this.setState({ isLoadingScheduled: true })
    try {
      const { data } = await this.processGraphQL.getScheduleByUser(this.userId, [StatusProcess.PENDENT, StatusProcess.IN_PROGRESS])
      
      if (data && data.getSchedulesByUser && data.getSchedulesByUser.length) {
        const now = moment().format('YYYY-MM-DD HH:mm:ss')
        const scheduledRAW = this.treatScheduleds(data.getSchedulesByUser)
        let schedules = [...data.getSchedulesByUser]
        schedules = schedules.map((s: any) => {
          const endDate = new Date(s.to)
          const end = moment(endDate).format('YYYY-MM-DD HH:mm:ss')
          const isOverdue = now > end && s.status !== 3;
          
          return {
            key: s.id,
            id: s.id,
            name: s.process.name || "-",
            createdAt: s.createAt || "-",
            status: isOverdue ? 5 : s.status,
            to: new Date(s.to).toLocaleString('pt-BR'),
            tags: s.tags || null
          }
        })
        
        this.setState({ scheduled: schedules, scheduledRAW: scheduledRAW, filteredScheduled: schedules, isLoadingScheduled: false })
      }else{
        this.setState({ isLoadingScheduled: false })
      }
    } catch (e) {
      console.error('erro ao carregar processos agendados', e)
      this.setState({ isLoadingScheduled: false })
    }
  }

  async loadUnscheduled () {
    this.setState({ isLoadingUnscheduled: true })
    try {
      const { items } = await this.processService.paging({
        unit: this.unitId,
        limit: 100,
        offset: 0,
        loadAPI: true
      })
      if (items && items.length) {
        const unscheduledRAW = this.treatUnscheduleds(items)
        let schedules = [...items]
        schedules = schedules.map((s: any) => {
          return {
            key: s.id,
            id: s.id,
            name: s.name || "-",
            createdAt: s.createdAt || "-",
            status: 6
          }
        })

        this.setState({ unscheduled: schedules, unscheduledRAW: unscheduledRAW, filteredUnscheduled: schedules, isLoadingUnscheduled: false })
      }else{
        this.setState({ isLoadingUnscheduled: false })
      }
    } catch (e) {
      console.error('erro ao carregar processos não agendados', e)
      this.setState({ isLoadingUnscheduled: false })
    }
  }

  handleExecScheduled (id: any) {
    const { scheduledRAW } = this.state
    const process = scheduledRAW.find((s: any) => {
      return s.schedulerId === id
    })
    return process
  }

  handleExecUnscheduled (id: any) {
    const { unscheduledRAW } = this.state
    const process = unscheduledRAW.find((s: any) => {
      return s.schedulerId === id
    })
    return process
  }

  treatScheduleds (schedules: any) {
    const processes = [];
    for (let schedule of schedules) {
      const newDate = new Date(schedule.from)
      const finalDate = newDate.toLocaleString('pt-BR')
      const process = Object.assign({}, schedule.process, {
        schedulerId: schedule.id,
        scheduleTitle: schedule.title,
        processName: schedule.process.name,
        user: this.userName,
        from: finalDate,
        processStatus: schedule.status,
        tags: schedule.tags || {}
      });

      processes.push(process);
    }
    return processes
  }

  treatUnscheduleds(schedules: any) {
    const processes = [];
    for (let schedule of schedules) {
      const process = Object.assign({}, schedule, {
        schedulerId: schedule.id,
        scheduleTitle: schedule.name_s,
        processName: schedule.name,
        user: this.userName
      });

      processes.push(process);
    }
    return processes
  }

  handleChangeFilters (checkedValues: any) {
    this.setState({ currentFilter: checkedValues })
  }

  handleSearch (search: any) {
    this.setState({ search })
  }

  filteredData () {
    const { currentFilter, search, scheduled, unscheduled } = this.state
    let filteredScheduled = [...scheduled]
    let filteredUnscheduled = [...unscheduled]

    filteredScheduled = filteredScheduled.filter((r: any) => {
      const hasStatus = currentFilter.includes(r.status)
      const name = r.name.toLowerCase()
      const term = search.trim().toLowerCase()
      const regex = new RegExp(term, 'g')
      const correspondsToSearch = search.trim().length > 0 ? name.match(regex) : true

      return hasStatus && correspondsToSearch
    })

    filteredUnscheduled = filteredUnscheduled.filter((r: any) => {
      const name = r.name.toLowerCase()
      const term = search.trim().toLowerCase()
      const regex = new RegExp(term, 'g')
      const correspondsToSearch = search.trim().length > 0 ? name.match(regex) : true

      return correspondsToSearch
    })

    this.setState({ filteredScheduled, filteredUnscheduled })
  }

  render() {
    const { activeTab, filteredScheduled, filteredUnscheduled, isLoadingScheduled, isLoadingUnscheduled, currentFilter } = this.state
    
    return (<Wrapper>
      <div className="header">
        <h1 className="title">{I18n.l('routes.my_processes')}</h1>
      </div>

      <SearchComponent
        currentFilter={currentFilter}
        onChangeFilters={this.handleChangeFilters}
        onSearch={this.handleSearch}
        activeTab={activeTab}
      />

      <Tabs defaultActiveKey={activeTab} onChange={(val) => this.setState({ activeTab: val })}>
        <TabPane tab={I18n.l('my_processes.scheduled')} key={'scheduled'}>
          {!isLoadingScheduled &&  filteredScheduled.length > 0 && <TableComponent
            columns={this.tableColumns}
            data={filteredScheduled}
            showConfirmationModal={false}
            onExec={this.handleExecScheduled}
            status={true}
            noPagination={true}
            loadScheduled={this.loadScheduled}
            processType='scheduled'
          />}

          {isLoadingScheduled && <div>
            {I18n.l('common.loadingData')}
          </div>}
          {!isLoadingScheduled && filteredScheduled.length === 0 && <div>
            {I18n.l('common.emptyData')}
          </div>}
        </TabPane>

        <TabPane tab={I18n.l('my_processes.unscheduled')} key={'unscheduled'}>
          {!isLoadingUnscheduled && filteredUnscheduled.length > 0 && <TableComponent
            columns={this.tableColumns}
            data={filteredUnscheduled}
            showConfirmationModal={false}
            onExec={this.handleExecUnscheduled}
            status={true}
            noPagination={true}
            loadUnscheduled={this.loadUnscheduled}
            processType='unscheduled'
          />}

          {isLoadingUnscheduled && <div>
            {I18n.l('common.loadingData')}
          </div>}
          {!isLoadingUnscheduled && filteredUnscheduled.length === 0 && <div>
            {I18n.l('common.emptyData')}
          </div>}
        </TabPane>
      </Tabs>
    </Wrapper>)
  }
}

export default MyProcessesContainer

const Wrapper = styled.div`
  flex: 1;
  padding: 40px 50px;
  margin-left: 180px;
  margin-top: 100px;
  max-width: 100%;
  width: 100%;

  .title {
    color: black;
    font-size: 48px;
    font-weight: bold;
    padding-bottom: 3rem;
  }

  tr.overdue {
    background-color: #FFDEDE;
    .overdue-label {
      color: #D93838;
    }
  }
`;